import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

export const VIRTUAL_BUNDLE_SALES_DETAILS_SUCCESS = 'VIRTUAL_BUNDLE_SALES_DETAILS_SUCCESS';
export const VIRTUAL_BUNDLE_SALES_DETAILS_LOADING = 'VIRTUAL_BUNDLE_SALES_DETAILS_LOADING';

const { VirtualBundleSalesDetails: { getVirtualBundleSalesDetails } } = apiUrls;


export const getVirtualBundleSalesDetailData = () => async (dispatch) => {
  try {
// console.log(bodyData)
    const requestData = {
        ...getVirtualBundleSalesDetails,
        url: getVirtualBundleSalesDetails.url,
    };
    const data = await REQUEST(requestData);
    dispatch({
      type: VIRTUAL_BUNDLE_SALES_DETAILS_SUCCESS,
      data,
    })
  } catch (e) {

    dispatch({
      type: VIRTUAL_BUNDLE_SALES_DETAILS_SUCCESS,
      data: {
        code: "",
        modal: null,
        notifications: null,
        paginationInfo: null
      }
    })
  }

}

export const handleLoader = isLoading => (dispatch) => {
  dispatch({
    type: VIRTUAL_BUNDLE_SALES_DETAILS_LOADING,
    isLoading
  })
}
